import React from 'react'

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { BASE_URLS, PLATFORM_TYPE } from '../constants/constants'
import { parseJwt } from '../components/utilities/utils'

export const sendSmsServiceApi = createApi({
  reducerPath: 'sendSmsServiceApi',
  keepUnusedDataFor: 0.001,
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URLS.FINALIZE_GENERATE_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      return headers;
    }, 
  
  }),
  endpoints: (builder) => ({
    SendSmsToRecord: builder.mutation({
      query: (data) => ({
        url: `v1/public/finalize/sendOfficer`,
        method: 'POST',
        body:data,
        headers: {
          'Content-Type': 'application/json',
         'authorization':`Bearer ${localStorage.access_token}`,
         'currentRole':localStorage.userrole
        },
      }),
    }),
  }),
})

export const {useSendSmsToRecordMutation}=sendSmsServiceApi
